// Clients can optionally provide the callbackTimeoutPeriod parameter

export let DoneState = /*#__PURE__*/function (DoneState) {
  DoneState[DoneState["NOOP"] = 0] = "NOOP";
  DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
  DoneState[DoneState["ERROR"] = 2] = "ERROR";
  return DoneState;
}({});